module.exports = __webpack_public_path__ + "static/media/behance.4719097e.svg";